<template>
  <div>
    <div class="text-center"><img src="@/assets/logo.jpg" width="150px" style="margin:20% 0 10% 0"></div>
    <h3 class="text-center">绑定账号</h3>
    <van-divider />
    <van-form @submit="submit">
      <van-cell-group inset>
        <van-field
          v-model="model.name"
          label="您的姓名"
          placeholder="请输入姓名"
          maxlength="10"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="model.mobile"
          label="变更手机"
          placeholder="请输入手机号"
          maxlength="11"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="model.code"
          center
          clearable
          label="短信验证码"
          placeholder="请输入验证码"
          maxlength="6"
          :rules="[{ required: true }]"
        >
          <template #button>
            <van-button size="small" type="primary" native-type="button" @click="sendCode()" :disabled="count_down!=='获取验证码'">{{count_down}}</van-button>
          </template>
        </van-field>
      </van-cell-group>

      <div class="line" />

      <div style="margin:20% 10px 0 10px;">
        <van-button round block type="primary" native-type="submit">绑定账号</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  created () {
  },
  data () {
    return {
      uri: this.$route.query.uri,

      model: {
        mobile: '',
        name: '',
        code: ''
      },

      count_down: '获取验证码'
    }
  },
  methods: {
    countDown (second) {
      second = second !== undefined ? second : this.count_down
      if (second > 0) {
        second = second - 1
        this.count_down = second
        setTimeout(() => this.countDown(), 1000)
      } else {
        this.count_down = '获取验证码'
      }
    },
    sendCode () {
      if (this.model.mobile === '') {
        this.$toast.fail('请输入手机号')
        return false
      }
      if (!/^1\d{10}$/.test(this.model.mobile)) {
        this.$toast.fail('手机格式错误')
        return false
      }

      Api.post('sms.verify/create', {type: 10, mobile: this.model.mobile}, res => {
        this.$toast.success('短信发送成功')
        this.countDown(60)
      })
    },
    submit () {
      if (this.model.mobile === '') {
        this.$toast.fail('请输入手机号')
        return false
      }
      if (!/^1\d{10}$/.test(this.model.mobile)) {
        this.$toast.fail('手机格式错误')
        return false
      }
      this.$dialog.confirm({title: '提示', message: '确认绑定吗？'})
        .then(() => {
          Api.post('cus.user/bind', {
            mobile: this.model.mobile,
            name: this.model.name,
            code: this.model.code
          }, res => {
            // this.$dialog.confirm({
            //   title: '提示',
            //   message: '请完善基本信息',
            //   confirmButtonText: '去完善',
            //   cancelButtonText: '返回'
            // })
            //   .then(() => {
            //     this.$router.push({path: '/wei/user/modify'})
            //   })
            //   .catch(() => {
            //     this.$router.push({path: this.uri})
            //   })
            this.$router.push({path: this.uri})
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Bind.vue